import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '..';
import './styles.scss';

const Loader = (props) => {
  switch (props.type) {
    case ('small-loader'):
      return (
        <Icon name={props.type} color={props.color === 'light' ? '#fff' : '#111'} />
      );
    case ('big-loader'):
      return (
        <Icon name={props.type} />
      );
    default:
      return null;
  }
};
Loader.propTypes = {
  color: PropTypes.string,
  type: PropTypes.oneOf(['small-loader', 'big-loader']),
};
Loader.defaultProps = {
  color: 'dark',
  type: 'small-loader',
};

export default Loader;
